// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"126":"507197b7","171":"88ca5efa","260":"c3b40255","388":"58c68ee4","453":"e5407da2","696":"e646f69c","780":"c6cb501c"}[chunkId] + ".chunk.js";
};